import { configureStore } from "@reduxjs/toolkit";
import homeReducer from "../slice/homeSlice";
import workReducer from "../slice/workSlice";
import whatWeDoReducer from "../slice/whatWeDoSlice";
import teamReducer from '../slice/teamSlice';
import officeReducer from '../slice/officeSlice';
import howWeDoReducer from '../slice/howWeDoSlice';
import configReducer from '../slice/configSlice';
import blogReducer from '../slice/blogSlice';
import podcastReducer from '../slice/podcastSlice';
import partnerReducer from '../slice/partnerSlice';
import influencerReducer from '../slice/influencerSlice';
import clientReducer from '../slice/clientSlice';

const store = configureStore({
  reducer: {
    home: homeReducer,
    work : workReducer,
    whatWeDo : whatWeDoReducer,
    team : teamReducer,
    office : officeReducer,
    howWeDo : howWeDoReducer,
    config : configReducer,
    blog : blogReducer,
    podcast : podcastReducer,
    partner : partnerReducer,
    influencer : influencerReducer,
    client : clientReducer,
  },
});

export default store;
